module.exports = __webpack_public_path__ + "assets/img/img84.d1f30ad4.png";